export default __webpack_public_path__ + "static/media/mr.1fdeee73.svg";